import { TranslationKeys } from './types';

const PLATE_KEY = /^(\d+)x(\d+) (\w+) plate$/;
const BASEPLATE_KEY = /^(\d+)x(\d+) baseplate$/;

export function formatInventoryKey(key: string, t: TranslationKeys): string {
  const plateMatch = key.match(PLATE_KEY);
  if (plateMatch) {
    const size = Number(plateMatch[1]);
    const color = plateMatch[3];
    return t.inventoryPlate(size, color);
  }

  const baseplateMatch = key.match(BASEPLATE_KEY);
  if (baseplateMatch) {
    return t.inventoryBaseplate(Number(baseplateMatch[1]), Number(baseplateMatch[2]));
  }

  return key;
}
